// extracted by mini-css-extract-plugin
module.exports = {"bold":"AdditionalFiltersButton_bold__JQyqy","ub":"AdditionalFiltersButton_ub__1qfzG"};